import { WorkwearExpressBundleDataBundledCustomisationInterface } from 'swagger/ts/Definitions';
import {
    CustomisationFull,
    formStateToCustomisationPayload,
} from 'src/components/CustomisationPage/feature/customisation.types';
import { ARTWORK_FORM_FIELD, ARTWORK_FORM_LOCATION_PREFIX } from 'src/components/BundleProduct/bundle-product.types';
import { ARTWORK, ARTWORK_EXISTING } from 'src/components/Artwork/artwork.types';
import { MaybeCustomisation } from 'src/components/BundleProduct/utils/formDataToPayload';
import camelcaseKeys from 'camelcase-keys';
import Bugsnag from '@bugsnag/js';
import { toNotifiableError } from 'src/util/general';

export type bundleCustomisationProps = {
    applicationMethod?: string;
    applicationType?: string;
    isContactRequested?: string;
    image?: string;
    color?: string;
    customisationName?: string;
    font?: string;
    specialInstructions?: string;
    textLineOne?: string;
    textLineThree?: string;
    textLineTwo?: string;
};

type onlyArtworksDataProps = {
    artwork: string;
    ['bundle-customisation']: bundleCustomisationProps;
    ['bundle-customisation-location']: string;
    ['locations-mirror']: string;
};

export const getOnlyArtworksData = (values: Record<string, onlyArtworksDataProps>) => {
    const artworksData: bundleCustomisationProps = {};
    for (const [key, value] of Object.entries(values)) {
        if (!isNaN(parseInt(key))) {
            artworksData[key] = value;
        }
    }
    return artworksData;
};

/**s
 * Convert a form into a valid customisation
 * @param formValues
 */
export const formToCustomisation = (formValues: Record<string, any>): MaybeCustomisation[] | undefined => {
    const artworksData = getOnlyArtworksData(formValues);
    const result: (WorkwearExpressBundleDataBundledCustomisationInterface | undefined)[] = [];

    Object.entries(artworksData).map((logo, index) => {
        const artwork: string = logo[1] || '';
        const artworkIsFree = index === 0;
        const artworkExistInDB = artwork[ARTWORK] === 'logoExist' ? 1 : 0;

        if (artwork[ARTWORK] === 'none') {
            return;
        }
        if (artwork[ARTWORK_EXISTING]) {
            try {
                const obj: CustomisationFull = JSON.parse(artwork[ARTWORK_EXISTING]);
                const customisation: WorkwearExpressBundleDataBundledCustomisationInterface = {
                    location: artwork[ARTWORK_FORM_LOCATION_PREFIX],
                    customisation: {
                        ...camelcaseKeys(obj, { deep: true }),
                        isFree: artworkIsFree,
                    },
                };
                return result.push(customisation);
            } catch (e) {
                Bugsnag.notify(toNotifiableError(e));
                return result.push(undefined);
            }
        }
        if (artwork[ARTWORK_FORM_FIELD]) {
            const customisation = {
                location: artwork[ARTWORK_FORM_LOCATION_PREFIX],
                customisation: formStateToCustomisationPayload(
                    artwork[ARTWORK_FORM_FIELD],
                    artworkIsFree,
                    artworkExistInDB,
                ),
            };
            return result.push(customisation);
        }
    });

    if (result.length === 0) {
        return;
    }
    return result;
};
